import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';

import { useFeatureSwitches } from '@xing-com/crate-hooks-use-feature-switches';
import { useLoggedInUser } from '@xing-com/crate-hooks-use-logged-in-user';

import * as appcues from './appcues';

export const APPCUES_FEATURESWITCH = 'use_appcues';

export const useAppcues = (shouldExecute = true) => {
  const { pathname } = useLocation();
  const intl = useIntl();
  const featureSwitches = useFeatureSwitches();
  const user = useLoggedInUser();

  const [appcuesData] = useState({
    language: intl?.locale ?? '',
  });

  const hasFeatureSwitch = Boolean(
    featureSwitches?.includes(APPCUES_FEATURESWITCH)
  );

  const canExecuteAppcues = shouldExecute && hasFeatureSwitch;

  useEffect(() => {
    const element = appcues.getElement();
    const isLoaded = appcues.isLoaded();

    if (canExecuteAppcues && user) {
      const id = String(user?.id);

      if (!element) {
        appcues.createElement(id, appcuesData);
      } else if (isLoaded) {
        appcues.loadResources(id, appcuesData);
      }
    } else {
      if (element) {
        appcues.deleteElement();
        if (isLoaded) appcues.resetResources();
      }
    }

    return () => {
      const isLoaded = appcues.isLoaded();
      if (canExecuteAppcues && isLoaded) {
        appcues.resetResources();
      }
    };
  }, [canExecuteAppcues, user, pathname, appcuesData]);
};

export default useAppcues;
